import { api } from '../api';

export interface ChatCitation {
  path: string;
  start_line: number;
  end_line: number;
  text: string;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: string;
  citations?: ChatCitation[];
}

export interface ChatResponse {
  answer: string;
  citations: ChatCitation[];
}

export interface ChatRequestPayload {
  message: string;
  conversation?: ChatMessage[];
}

export const sendChatMessage = async (payload: ChatRequestPayload): Promise<ChatResponse> => {
  const response = await api.post('api/chat', { json: payload });
  return response.json<ChatResponse>();
};
